<template>
<nav aria-label="breadcrumb" class="breadcrumb-area">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
	<li class="breadcrumb-item"><router-link to="/mypage/index">マイページ</router-link></li>
    <li class="breadcrumb-item active" aria-current="page">パスワード変更完了</li>
  </ol>
</nav>
	<div class="container-fluid">
		<div class="row mypage-contents">
			<side-bar/>
			<div class="mypage-contents_contents ml-sm-auto px-md-4 py-4">
				<h1 class="h2">パスワード変更完了</h1>
				<div class="top--section">
					<p class="mb-3">
						パスワード変更が完了しました。
					</p>
					<router-link class="btn btn-primary" to="/mypage/index">マイページへ戻る</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import SideBar from '@/components/Layouts/SideBar.vue'
</script>

